var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5124 34.9784L49.3404 23.7998H47.0114L38.4778 33.506L31.662 23.7998H23.8008L34.1076 38.4773L23.8008 50.1998H26.1298L35.1416 39.9497L42.3396 50.1998H50.2008L39.5118 34.9784H39.5124ZM36.3224 38.6066L35.2781 37.1451L26.969 25.5154H30.5463L37.2518 34.9009L38.2961 36.3625L47.0125 48.5623H43.4353L36.3224 38.6072V38.6066Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7365950132dc78078b975e6a4379eaf2.svg";
export { ForwardRef as ReactComponent };